/**
 * GE logo component. Uses the real logo pulled from the live site (public/brand/logo.png).
 * Variants: "full" (logo + wordmark), "mark" (just the logo mark), "dark" (for dark backgrounds — white tint via CSS).
 */
export default function Logo({ variant = "full", className = "", invert = false }) {
  const img = (
    <img
      src="/brand/logo.png"
      alt="Genius Education"
      className={`h-10 w-auto object-contain ${invert ? "brightness-0 invert" : ""}`}
      style={{ maxWidth: variant === "mark" ? 48 : 200 }}
      data-testid="brand-logo"
    />
  );

  if (variant === "mark") {
    return <div className={className}>{img}</div>;
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {img}
    </div>
  );
}
